module.exports = __webpack_public_path__ + "img/icon_task.4f6c85fb.svg";